export default __webpack_public_path__ + "static/media/blueVehicle.92e9dc30.png";